export default {
  CountryFormField__ARIA: "Country",
  CountryFormField__INVALID: "Select a valid Country",
  CountryFormField__LABEL: "Country",
  CountryFormField__NO_MATCH_FOUND: "No match found",
};
